const dishonLocations = [{
    name: "CENTRO DISH ANÁHUAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "SAN NICOLÁS DE LOS GARZA",
    postalCode: "66450",
    suburb: "ANÁHUAC",
    street: "AVE. UNIVERSIDAD NORTE",
    externalNumber: "101",
    coordinates: {
        lat: 25.741787,
        lng: -100.302666
    }
}, {
    name: "CENTRO DISH ESCOBEDO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "ESCOBEDO",
    postalCode: "66056",
    suburb: "GIRASOLES",
    street: "AVE. RAÚL SALINAS LOZANO",
    externalNumber: "927",
    coordinates: {
        lat: 25.766337,
        lng: -100.315847
    }
}, {
    name: "CENTRO DISH LINCOLN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "MONTERREY",
    postalCode: "64330",
    suburb: "AMPLIACIÓN SAN JORGE",
    street: "AVE. LINCOLN",
    externalNumber: "5252",
    coordinates: {
        lat: 25.726235,
        lng: -100.367758
    }
}, {
    name: "CENTRO DISH CATARINA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "MONTERREY",
    postalCode: "66100",
    suburb: "LA FAMA",
    street: "BOULEVARD DIAZ ORDAZ",
    externalNumber: "108",
    coordinates: {
        lat: 25.674129,
        lng: -100.421956
    }
}, {
    name: "CENTRO DISH SANTA MARÍA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "GUADALUPE",
    postalCode: "67190",
    suburb: "SANTA MARIAN",
    street: "AV. PABLO LIVAS",
    externalNumber: "7500",
    coordinates: {
        lat: 25.674181,
        lng: -100.422009
    }
}, {
    name: "SORIANA FÉLIX U. GÓMEZ",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "MONTERREY",
    postalCode: "64510",
    suburb: "JUANA DE ARCO",
    street: "AVE. FELIX U. GÓMEZ",
    externalNumber: "1732",
    coordinates: {
        lat: 25.707248,
        lng: -100.284919
    }
}, {
    name: "SORIANA FRESNOS",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "APODACA",
    postalCode: "66635",
    suburb: "LAS PRADERAS",
    street: "MANUEL HERRERA",
    externalNumber: "101",
    coordinates: {
        lat: 25.772948,
        lng: -100.260345
    }
}, {
    name: "SORIANA HUINALÁ",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "APODACA",
    postalCode: "66640",
    suburb: "HACIENDA HUINALÁ",
    street: "CARRETERA HUINALÁ",
    externalNumber: "1300",
    coordinates: {
        lat: 25.745053,
        lng: -100.183181
    }
}, {
    name: "SORIANA LAS QUINTAS",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "GUADALUPE",
    postalCode: "67160",
    suburb: "LAS QUINTAS",
    street: "ADOLFO LÓPEZ MATEOS",
    externalNumber: "501",
    coordinates: {
        lat: 25.690630,
        lng: -100.212700
    }
}, {
    name: "SORIANA SANTO DOMINGO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "SAN NICOLÁS DE LOS GARZA",
    postalCode: "66444",
    suburb: "SANTO DOMINGO",
    street: "AV. SANTO DOMINGO",
    externalNumber: "1800",
    coordinates: {
        lat: 25.751031,
        lng: -100.255709
    }
}, {
    name: "SORIANA TOPOCHICO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "MONTERREY",
    postalCode: "64215",
    suburb: "LIBERTADORES",
    street: "LA ESPERANZA",
    externalNumber: "6600",
    coordinates: {
        lat: 25.724645,
        lng: -100.341911
    }
}, {
    name: "SORIANA VALLE SOLEADO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "MONTERREY",
    postalCode: "64117",
    suburb: "VALLE SOLEADO",
    street: "AVE. RUIZ CORTINEZ",
    externalNumber: "5850",
    coordinates: {
        lat: 25.708433,
        lng: -100.197151
    }
}, {
    name: "WALMART LINDAVISTA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "NUEVO LEÓN",
    city: "GUADALUPE",
    postalCode: "67139",
    suburb: "RIVERAS DE LA PURÍSIMA",
    street: "CARRETERA MIGUEL ALEMÁN",
    externalNumber: "200",
    coordinates: {
        lat: 25.694115,
        lng: -100.240110
    }
}, {
    name: "PLAZA SAN ISIDRO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "ZAPOPAN",
    postalCode: "45204",
    suburb: "BOSQUES DE SAN ISIDRO",
    street: "ANILLO PERIFERICO",
    externalNumber: "221",
    coordinates: {
        lat: 20.742257,
        lng: -103.384821
    }
}, {
    name: "BODEGA AURRERA REVOLUCION",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "SAN PEDRO TLAQUEPAQUE",
    postalCode: "45540",
    suburb: "SEC. HIDALGO",
    street: "AVENIDA REVOLUCION",
    externalNumber: "720",
    coordinates: {
        lat: 20.122853,
        lng: -98.733738
    }
}, {
    name: "CHEDRAUI FEDERALISMO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "ZAPOPAN",
    postalCode: "45130",
    suburb: "QUINTAS DEL FEDERALISMO",
    street: "PROLONGACION FEDERALISMO NORTE",
    externalNumber: "1786",
    coordinates: {
        lat: 20.735947,
        lng: -103.350157
    }
}, {
    name: "WALMART REVOLUCION",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "GUADALAJARA",
    postalCode: "44400",
    suburb: "SECTOR REFORMA",
    street: "RAMON VELARDE",
    externalNumber: "821",
    coordinates: {
        lat: 20.649161,
        lng: -103.310105
    }
}, {
    name: "PLAZA LAS TORRES",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "GUADALAJARA",
    postalCode: "44919",
    suburb: "8 DE JULIO",
    street: "AVENIDA 8 DE JULIO",
    externalNumber: "1896",
    coordinates: {
        lat: 20.648763,
        lng: -103.361711
    }
}, {
    name: "BODEGA AURRERA SAN GASPAR",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "TONALÁ",
    postalCode: "45403",
    suburb: "LOS CAMICHINES I",
    street: "PROLONGACION PABLO VALDEZ",
    externalNumber: "350",
    coordinates: {
        lat: 20.676955,
        lng: -103.255682
    }
}, {
    name: "PLAZA INDEPENDENCIA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "GUADALAJARA",
    postalCode: "44300",
    suburb: "RICARDO FLORES MAGÓN",
    street: "CALZ. INDEPENDENCIA",
    externalNumber: "3295",
    coordinates: {
        lat: 20.719463,
        lng: -103.319355
    }
}, {
    name: "CHEDRAUI LOMAS",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "JALISCO",
    city: "GUADALAJARA",
    postalCode: "45403",
    suburb: "VILLAS DE ORIENTE I",
    street: "AVENIDA RIO NILO",
    externalNumber: "7540",
    coordinates: {
        lat: 20.650842,
        lng: -103.278513
    }
}, {
    name: "WALMART EDUARDO MOLINA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "G.A.M.",
    postalCode: "7090",
    suburb: "D.M. NACIONAL",
    street: "CALZADA SAN JUAN DE ARAGÓN",
    externalNumber: "516",
    coordinates: {
        lat: 19.479784,
        lng: -99.095596
    }
}, {
    name: "WALMART LAGO DE GUADALUPE",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TLALNEPANTLA",
    postalCode: "54010",
    suburb: "SAN PEDRO BARRIENTOS",
    street: "LAGO DE GPE",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.579611,
        lng: -99.211101
    }
}, {
    name: "WALMART AZCAPOTZALCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "AZCAPOTZALCO",
    postalCode: "02770",
    suburb: "SANTA CRUZ ACAYUCAN",
    street: "AV. NEXTENGO",
    externalNumber: "78",
    coordinates: {
        lat: 19.473145,
        lng: -99.192522
    }
}, {
    name: "WALMART VILLA COAPA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "COYOACAN",
    postalCode: "14390",
    suburb: "SAN BARTOLO COAPA",
    street: "AV. CANAL DE MIRAMONTES",
    externalNumber: "3520",
    coordinates: {
        lat: 19.293250,
        lng: -99.123775
    }
}, {
    name: "WALMART AEROPUERTO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "VENUSTIANO CARRANZA",
    postalCode: "15700",
    suburb: "FEDERAL",
    street: "CALZADA IGNACIO ZARAGOZA",
    externalNumber: "58",
    coordinates: {
        lat: 19.419719,
        lng: -99.093814
    }
}, {
    name: "WALMART BUENAVISTA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "CUAUHTEMOC",
    postalCode: "06300",
    suburb: "GUERRERO",
    street: "INSURGENTES NORTE",
    externalNumber: "131",
    coordinates: {
        lat: 19.443904,
        lng: -99.153177
    }
}, {
    name: "WALMART TLALPAN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "BENITO JUÁREZ",
    postalCode: "03500",
    suburb: "AMERICAS UNIDAS",
    street: "CALZADA TLALPAN",
    externalNumber: "1037",
    coordinates: {
        lat: 19.380559,
        lng: -99.141277
    }
}, {
    name: "WALMART CUITLAHUAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "AZCAPOTZALCO",
    postalCode: "0.0282",
    suburb: "HOGAR Y SEGURIDAD",
    street: "AV. CUITLÁHUAC",
    externalNumber: "3651",
    coordinates: {
        lat: 19.471416,
        lng: -99.164409
    }
}, {
    name: "WALMART MIRAMONTES",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "COYOACAN",
    postalCode: "04890",
    suburb: "PRESIDENTES EJIDALES",
    street: "AV. ESCUELA NAVAL MILITAR",
    externalNumber: "753",
    coordinates: {
        lat: 19.319058,
        lng: -99.125581
    }
}, {
    name: "WALMART TLAHUAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "TLAHUAC",
    postalCode: "13266",
    suburb: "SAN LORENZO TEZONCO",
    street: "CALZ. TLÁHUAC",
    externalNumber: "5662",
    coordinates: {
        lat: 19.308258,
        lng: -99.059731
    }
}, {
    name: "WALMART TEPEYAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "G.A.M.",
    postalCode: "00784",
    suburb: "GUADALUPE TEPEYAC",
    street: "CALZ. DE GUADALUPE",
    externalNumber: "431",
    coordinates: {
        lat: 19.472993,
        lng: -99.121206
    }
}, {
    name: "WALMART CD. JARDIN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NEZAHUALCOYOTL",
    postalCode: "50000",
    suburb: "BENITO JUÁREZ",
    street: "AV. BORDO DE XOCHIACA",
    externalNumber: "3",
    coordinates: {
        lat: 19.425668,
        lng: -99.029015
    }
}, {
    name: "WALMART PLAZA ORIENTE",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "00902",
    suburb: "DR. ALFONSO ORTIZ TIRADO",
    street: "AV. CANAL DE TEZONTLE",
    externalNumber: "1520",
    coordinates: {
        lat: 19.384390,
        lng: -99.080517
    }
}, {
    name: "WALMART IXTAPALUCA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "IXTAPALUCA",
    postalCode: "56530",
    suburb: "HACIENDA DE SANTA BARBARA",
    street: "CARRETERA MEXICO- CUAUTLA",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.299578,
        lng: -98.885891
    }
}, {
    name: "WALMART SAN MARCOS IZCALLI",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CUAUTITLAN IZCALLI",
    postalCode: "54720",
    suburb: "JARDINES DE LA HACIENDA",
    street: "AV. CHALMA",
    externalNumber: "281",
    coordinates: {
        lat: 19.671488,
        lng: -99.204920
    }
}, {
    name: "WALMART CANTIL",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "COYOACAN",
    postalCode: "4360",
    suburb: "LOS REYES COYOACAN",
    street: "AV. AZTECAS",
    externalNumber: "221",
    coordinates: {
        lat: 19.330824,
        lng: -99.154329
    }
}, {
    name: "WALMART TERRANOVA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ACOLMAN",
    postalCode: "55883",
    suburb: "GEOVILLAS DE TERRANOVA ACOLMAN",
    street: "BOULEVARD DEL LAGO",
    externalNumber: "N° 1-A, MZA1, LOTE 03.",
    coordinates: {
        lat: 19.607115,
        lng: -98.974505
    }
}, {
    name: "WALMART AYOTLA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "IXTAPALUCA",
    postalCode: "56560",
    suburb: "AYOTLA",
    street: "CARRETERA FEDERAL MEXICO-PUEBLA",
    externalNumber: "KM 27.5 N° 6",
    coordinates: {
        lat: 19.319283,
        lng: -98.938599
    }
}, {
    name: "WALMART LA PAZ",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "LOS REYES ACAQUILPAN",
    postalCode: "56410",
    suburb: "EL SALADO LA PAZ",
    street: "AV. RÍO BRAVO",
    externalNumber: "6",
    coordinates: {
        lat: 19.369591,
        lng: -98.962487
    }
}, {
    name: "WALMART PLAZA CHIMALHUACAN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CHIMALHUACAN",
    postalCode: "5633",
    suburb: "CABECERA MUNICIPAL CHIMALHUACAN",
    street: "AV. NEZAHUALCOYOTL",
    externalNumber: "172",
    coordinates: {
        lat: 19.409158,
        lng: -98.927905
    }
}, {
    name: "WALMART IXTAPALUCA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "IXTAPALUCA",
    postalCode: "56577",
    suburb: "FRACC. HACIENDA DE SANTA BARBARA",
    street: "CARRETERA FEDERAL MEXICO-CUAUTLA",
    externalNumber: "MZA.2 LOTE 1",
    coordinates: {
        lat: 19.299365,
        lng: -98.885934
    }
}, {
    name: "WALMART IZTAPALAPA NORTE",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "9500",
    suburb: "SANTA MARIA AZTAHUACAN",
    street: "CALZ. ERMITA IZTAPALAPA",
    externalNumber: "# 3409",
    coordinates: {
        lat: 19.384308,
        lng: -99.080456
    }
}, {
    name: "WALMART PALOMAS",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC",
    postalCode: "55000",
    suburb: "LA VELETA ECATEPEC",
    street: "CALLE PALOMAS",
    externalNumber: "MZA. 1 LOTE 1",
    coordinates: {
        lat: 19.610104,
        lng: -99.017527
    }
}, {
    name: "WALMART LA VIRGEN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "COYOACAN",
    postalCode: "4480",
    suburb: "CULHUACAN",
    street: "CALZADA DE LA VIRGEN",
    externalNumber: "2990",
    coordinates: {
        lat: 19.322957,
        lng: -99.106655
    }
}, {
    name: "WALMART LOS REYES",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "LOS REYES ACAQUILPAN",
    postalCode: "56490",
    suburb: "EMILIANO ZAPATA",
    street: "KM. 17.5 CARR. LIB. MEX-PUE",
    externalNumber: "",
    coordinates: {
        lat: 19.790225,
        lng: -99.054691
    }
}, {
    name: "WALMART MELCHOR OCAMPO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CUAUTITLAN IZCALLI",
    postalCode: "54800",
    suburb: "BARRIO TLALTEPAN",
    street: "AV. MELCHOR OCAMPO",
    externalNumber: "1",
    coordinates: {
        lat: 19.677593,
        lng: -99.148299
    }
}, {
    name: "WALMART ZARAGOZA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "2210",
    suburb: "TEPALCATES",
    street: "CALZADA IGNACIO ZARAGOZA",
    externalNumber: "1527",
    coordinates: {
        lat: 19.419841,
        lng: -99.093857
    }
}, {
    name: "WALMART LOS ANGELES IZTAPALAPA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "9830",
    suburb: "LOS ANGELES",
    street: "AV. ERMITA IZTAPALAPA",
    externalNumber: "2001",
    coordinates: {
        lat: 19.346198,
        lng: -99.069293
    }
}, {
    name: "WALMART CABEZA DE JUAREZ",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "9220",
    suburb: "EJERCITO CONSTITUCIONALISTA",
    street: "ANILLO PERIFERICO",
    externalNumber: "1911",
    coordinates: {
        lat: 19.378336,
        lng: -99.059613
    }
}, {
    name: "WALMART TEXCOCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TEXCOCO",
    postalCode: "56116",
    suburb: "SAN PABLO TEXCOCO",
    street: "PROL. 16 SEP",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.516186,
        lng: -98.868287
    }
}, {
    name: "WALMART FUENTES DEL VALLE",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TULTITLAN",
    postalCode: "54910",
    suburb: "FUENTES DEL VALLE TULTITLAN",
    street: "VIA LOPEZ PORTILLO",
    externalNumber: "149",
    coordinates: {
        lat: 19.630212,
        lng: -99.123655
    }
}, {
    name: "WALMART 1° DE MAYO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NAUCALPAN",
    postalCode: "53500",
    suburb: "SAN ANDRES ATOTO",
    street: "AV. 1 MAYO Y RIO HONDO",
    externalNumber: "200",
    coordinates: {
        lat: 19.465625,
        lng: -99.234203
    }
}, {
    name: "WALMART VALLE DE ARAGON",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NEZAHUALCOYOTL",
    postalCode: "57100",
    suburb: "VALLE DE ARAGON",
    street: "VALLE SANTIAGO",
    externalNumber: "102",
    coordinates: {
        lat: 19.489486,
        lng: -99.054282
    }
}, {
    name: "WALMART LA AURORA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NEZAHUALCOYOTL",
    postalCode: "57000",
    suburb: "BENITO JUAREZ",
    street: "AV. CARMELO PEREZ",
    externalNumber: "774",
    coordinates: {
        lat: 19.406370,
        lng: -98.994607
    }
}, {
    name: "WALMART TACUBAYA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "MIGUEL HIDALGO",
    postalCode: "11870",
    suburb: "TACUBAYA",
    street: "PARQUE LIRA",
    externalNumber: "147",
    coordinates: {
        lat: 19.404622,
        lng: -99.187279
    }
}, {
    name: "WALMART RIO HONDO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NAUCALPAN",
    postalCode: "52810",
    suburb: "SAN JOSE RIO HONDO",
    street: "CAMINO ARENERO",
    externalNumber: "650",
    coordinates: {
        lat: 19.440299,
        lng: -99.247676
    }
}, {
    name: "WALMART SAN BUENAVENTURA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "IXTAPALUCA",
    postalCode: "56536",
    suburb: "SAN BUENAVENTURA",
    street: "PASEO SAN BUENAVENTURA",
    externalNumber: "15",
    coordinates: {
        lat: 19.310561,
        lng: -98.860799
    }
}, {
    name: "WALMART LA VIGA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "VENUSTIANO CARRANZA",
    postalCode: "15820",
    suburb: "LORENZO BOTURINI",
    street: "CALZ. LA VIGA",
    externalNumber: "136",
    coordinates: {
        lat: 19.416972,
        lng: -99.127172
    }
}, {
    name: "WALMART HUEHUETOCA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "HUEHUETOCA",
    postalCode: "54680",
    suburb: "BARRIO DE SALITRILLO HUEHUETOCA",
    street: "BLVD. JOROBAS-HUEHUETOCA",
    externalNumber: "KM 4.5",
    coordinates: {
        lat: 19.842017,
        lng: -99.238032
    }
}, {
    name: "WALMART LOS REYES ZUMPANGO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ZUMPANGO",
    postalCode: "55635",
    suburb: "BUENAVISTA",
    street: "CARRETERA ZUMPANGO LOS REYES",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.790316,
        lng: -99.054702
    }
}, {
    name: "WALMART LOS HEROES TECAMAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TECAMAC",
    postalCode: "55760",
    suburb: "LOS HEROES TECAMAC",
    street: "JOSÉ MARÍA PINO SUÁREZ",
    externalNumber: "52",
    coordinates: {
        lat: 19.619535,
        lng: -99.026031
    }
}, {
    name: "WALMART TEPOJACO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CUAUTITLAN IZCALLI",
    postalCode: "54720",
    suburb: "LOMAS DE SAN FRANCISCO TEPOJACO",
    street: "SAN FELIPE DE JESÚS",
    externalNumber: "MZNA 20, LTE 10",
    coordinates: {
        lat: 19.651072,
        lng: -99.261361
    }
}, {
    name: "WALMART GOBERNADORA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC",
    postalCode: "55108",
    suburb: "TULPETLAC",
    street: "AV. GOBERNAORA",
    externalNumber: "50",
    coordinates: {
        lat: 19.558791,
        lng: -99.024321
    }
}, {
    name: "WALMARTROSARIO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "AZCAPOTZALCO",
    postalCode: "02430",
    suburb: "TIERRA NUEVA",
    street: "AV. EL ROSARIO",
    externalNumber: "1025",
    coordinates: {
        lat: 19.502564,
        lng: -99.203661
    }
}, {
    name: "WALMART MACRO PLAZA HEROES",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TECAMAC",
    postalCode: "55764",
    suburb: "LOS HEROES TECAMAC",
    street: "BOSQUES DEL ESTADO DE MEXICO",
    externalNumber: "NO. 2 LOTE 1",
    coordinates: {
        lat: 19.617444,
        lng: -99.039196
    }
}, {
    name: "WALMART JOROBAS",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "HUEHUETOCA",
    postalCode: "54695",
    suburb: "STA TERESA 3 Y 3 BIS",
    street: "CARRETERA JOROBAS-TULA 03",
    externalNumber: "38 MANZANA 125 NTE 1",
    coordinates: {
        lat: 19.841912,
        lng: -99.238001
    }
}, {
    name: "WALMART CHIMALHUACAN PEÑON",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CHIMALHUACAN",
    postalCode: "56334",
    suburb: "XOCHITENCO",
    street: "AV. DEL PEÑON",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.421909,
        lng: -98.971518
    }
}, {
    name: "WALMART CHICOLOAPAN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CHICOLOAPAN",
    postalCode: "06370",
    suburb: "PUEBLO CENTRO CHICOLOAPAN",
    street: "CARRETERA MÉXICO TEXCOCO",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.429519,
        lng: -98.910386
    }
}, {
    name: "WALMART ARBOLEDA LOS SAUCES",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ZUMPANGO",
    postalCode: "55635",
    suburb: "LOS SAUCES II",
    street: "ARBOLADA LOS MAPLES",
    externalNumber: "141",
    coordinates: {
        lat: 19.812388,
        lng: -99.046710
    }
}, {
    name: "WALMART TOLUCA PILARES",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - METEPEC",
    postalCode: "52176",
    suburb: "BARRIO DE COAXUSTENCO",
    street: "AV. PROLONGACIÓN GOBERNADORES",
    externalNumber: "308 NORTE",
    coordinates: {
        lat: 19.269706,
        lng: -99.597579
    }
}, {
    name: "WALMART ZINACANTEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - ZINACANTEPEC",
    postalCode: "51350",
    suburb: "OJUELOS ZINACANTEPEC",
    street: "BOULEVARD ADOLFO LÓPEZ MATEOS",
    externalNumber: "117",
    coordinates: {
        lat: 19.287514,
        lng: -99.699451
    }
}, {
    name: "WALMART METEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - METEPEC",
    postalCode: "52840",
    suburb: "LA PURISIMA",
    street: "LEONA VICARIO",
    externalNumber: "502",
    coordinates: {
        lat: 19.267023,
        lng: -99.622884
    }
}, {
    name: "WALMART TOTOLTEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - TOLUCA",
    postalCode: "50245",
    suburb: "SANTA MARÍA TOTOLTEPEC",
    street: "VICENTE LOMBARDO TOLEDANO",
    externalNumber: "343",
    coordinates: {
        lat: 19.310181,
        lng: -99.586714
    }
}, {
    name: "WALMART TOLUCA ( TOLLOCAN )",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - TOLUCA",
    postalCode: "50150",
    suburb: "SECTOR PROGRESO",
    street: "PASEO TOLLOCAN",
    externalNumber: "600",
    coordinates: {
        lat: 19.281272,
        lng: -99.639442
    }
}, {
    name: "WALMART SANTIN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - TOLUCA",
    postalCode: "50200",
    suburb: "SAN MATEO OTZACATIPAN",
    street: "VIALIDAD TOLUCA-NAUCALPAN",
    externalNumber: "1101",
    coordinates: {
        lat: 19.351797,
        lng: -99.591199
    }
}, {
    name: "WALMART XALOSTOC, ECATEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC",
    postalCode: "55520",
    suburb: "HANK GONZALEZ",
    street: "AV. SAN ANDRES",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.550318,
        lng: -99.075199
    }
}, {
    name: "WALMART SANTA CLARA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC",
    postalCode: "55400",
    suburb: "TULPETLAC",
    street: "CARR. MEX-PACHUCA",
    externalNumber: "3277 KM. 17.5",
    coordinates: {
        lat: 19.699424,
        lng: -98.979965
    }
}, {
    name: "WALMART ECATEPEC CENTRO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC",
    postalCode: "55000",
    suburb: "SAN CRISTOBAL CENTRO",
    street: "AV . REVOLUCION",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.606498,
        lng: -99.045731
    }
}, {
    name: "WALMART IZTAPALAPA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "9820",
    suburb: "STA ISABEL IND.",
    street: "CALZ. ERMITA IZTAPALAPA",
    externalNumber: "875",
    coordinates: {
        lat: 19.355250,
        lng: -99.103893
    }
}, {
    name: "WALMART VILLAS DE AYOTLA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "IXTAPALUCA",
    postalCode: "",
    suburb: "VILLAS DE AYOTLA",
    street: "BOULEVARD CUAUHTEMOC",
    externalNumber: "4700",
    coordinates: {
        lat: 19.319202,
        lng: -98.938663
    }
}, {
    name: "WALMART PORTAL CHALCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CHALCO",
    postalCode: "56600",
    suburb: "SAN SEBASTIAN",
    street: "PROLONGACION SAN SEBASTIAN",
    externalNumber: "S7N LOTE 2",
    coordinates: {
        lat: 19.252870,
        lng: -98.905858
    }
}, {
    name: "WALMART CUAUTZINGO CHALCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CHALCO",
    postalCode: "56600",
    suburb: "SAN GREGORIO CUAUTZINGO",
    street: "AV. MORELOS",
    externalNumber: "S7N LOTE 2",
    coordinates: {
        lat: 19.261197,
        lng: -98.878014
    }
}, {
    name: "WALMART CIUDAD LABOR",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TULTITLAN",
    postalCode: "54940",
    suburb: "SAN FRANCISCO CHILPAN",
    street: "VIA JOSÉ LÓPEZ PORTILLO",
    externalNumber: "12",
    coordinates: {
        lat: 19.605441,
        lng: -99.181344
    }
}, {
    name: "WALMART LERMA TOLUCA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - LERMA",
    postalCode: "52006",
    suburb: "LA MERCED LERMA",
    street: "RIO LERMA",
    externalNumber: "5",
    coordinates: {
        lat: 19.283064,
        lng: -99.503386
    }
}, {
    name: "WALMART RIO DE LOS REMEDIOS",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TLALNEPANTLA",
    postalCode: "54180",
    suburb: "EX RANCHO SANTA CRUZ PUEBLO DE SAN JUAN IXHUATEPEC",
    street: "AV. RIO DE LOS REMEDIOS",
    externalNumber: "5",
    coordinates: {
        lat: 19.519062,
        lng: -99.117118
    }
}, {
    name: "WALMART TECAMAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TECAMAC",
    postalCode: "55765",
    suburb: "ESMERALDA",
    street: "Carretera federal Mexico-Pachuca",
    externalNumber: "65",
    coordinates: {
        lat: 19.660371,
        lng: -99.003306
    }
}, {
    name: "WALMART SAN JOSE TECAMAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TECAMAC",
    postalCode: "55741",
    suburb: "HUEYOTENCO",
    street: "CARRETERA FEDERAL MÉXICO - PACHUCA",
    externalNumber: "KM 36.5",
    coordinates: {
        lat: 19.699151,
        lng: -98.979847
    }
}, {
    name: "WALMART SANTA ELENA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CUAUTITLAN",
    postalCode: "54850",
    suburb: "TERREMOTO",
    street: "CARRETERA CUAUTITLAN-TULTEPEC",
    externalNumber: "2",
    coordinates: {
        lat: 19.677735,
        lng: -99.148313
    }
}, {
    name: "WALMART PLAZA ECATEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC DE MORELOS",
    postalCode: "55400",
    suburb: "SANTA MARIA TULPETLAC",
    street: "Av. Central Carlos Hank González",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.558092,
        lng: -99.019356
    }
}, {
    name: "WALMART TIANGUISTENCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "SANTIAGO TIANGUISTENCO",
    postalCode: "52600",
    suburb: "SANTIAGO TIANGUISTENCO",
    street: "AV. CATARINO GONZALEZ BENÍTEZ",
    externalNumber: "202",
    coordinates: {
        lat: 19.178148,
        lng: -99.469758
    }
}, {
    name: "WALMART TEOTIHUACAN",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TECAMAC",
    postalCode: "55760",
    suburb: "SAN FRANCISCO CUAUTLIQUIXCO",
    street: "Blvd Valle De Sn Pedro",
    externalNumber: "Lt 1 A",
    coordinates: {
        lat: 19.681132,
        lng: -98.864858
    }
}, {
    name: "WALMART OJO DE AGUA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TEOTIHUACAN",
    postalCode: "55760",
    suburb: "OJO DE AGUA",
    street: "Boulevard VALLE San PEDRO",
    externalNumber: "1A, Lote 56",
    coordinates: {
        lat: 19.659369,
        lng: -99.018491
    }
}, {
    name: "COMERCIAL MEXICANA MEGA MIXCOAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "BENITO JUÁREZ",
    postalCode: "03910",
    suburb: "MIXCOAC",
    street: "AV. REVOLUCION",
    externalNumber: "780",
    coordinates: {
        lat: 19.379621,
        lng: -99.186729
    }
}, {
    name: "COMERCIAL MEXICANA MEGA SAN JERONIMO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "MAGDALENA CONTRERAS",
    postalCode: "10200",
    suburb: "SAN JERONIMO LIDICE",
    street: "AV. SAN JERONIMO",
    externalNumber: "630",
    coordinates: {
        lat: 19.330103,
        lng: -99.208850
    }
}, {
    name: "COMERCIAL MEXICANA CUAUTITLAN IZCALLI",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CUAUTITLAN IZCALLI",
    postalCode: "54730",
    suburb: "CENTRO URBANO",
    street: "DR. JIMENEZ CANTU",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.647062,
        lng: -99.206824
    }
}, {
    name: "COMERCIAL MEXICANA SAN MIGUEL HUEHUETOCA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "SAN MIGUEL",
    postalCode: "54750",
    suburb: "FRACCIONAMIENTO EX-HACIENDA",
    street: "AV HUEHUETOCA",
    externalNumber: "1",
    coordinates: {
        lat: 19.832811,
        lng: -99.203866
    }
}, {
    name: "COMERCIAL MEXICANA ZUMPANGO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ZUMPANGO",
    postalCode: "56000",
    suburb: "BARRIO SAN JUAN",
    street: "JIMENEZ CANTÚ",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.797309,
        lng: -99.106159
    }
}, {
    name: "SORIANA IZTAPALAPA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "",
    suburb: "SAN FELIPE TERREMOTES",
    street: "CALZADA ERMITA IZTAPALAPA",
    externalNumber: "1863",
    coordinates: {
        lat: 19.349730,
        lng: -99.074388
    }
}, {
    name: "CHEDRAUI MEX. PALOMAS/ECATEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC",
    postalCode: "55065",
    suburb: "SANTA CRUZ VENTA DE CARPIÓ",
    street: "AV. CENTRAL ESQ. AV. JARDINES DE MOR.",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.603044,
        lng: -99.014509
    }
}, {
    name: "CHEDRAUI MEX. TECAMAC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TECAMAC",
    postalCode: "55740",
    suburb: "FRACCIONAMIENTO SIERRA HERMOSA",
    street: "AV. CARR-FEDERAL MÉXICO-PACHUCA KM-33.5.",
    externalNumber: "",
    coordinates: {
        lat: 19.689406,
        lng: -98.989049
    }
}, {
    name: "CHEDRAUI MEX. TENAYUCA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "G.A.M.",
    postalCode: "7268",
    suburb: "SOLIDARIDAD NACIONAL",
    street: "AV. LA VENTISCA",
    externalNumber: "100",
    coordinates: {
        lat: 19.529439,
        lng: -99.157425
    }
}, {
    name: "CHEDRAUI MEX. NEZAHUALCOYOTL",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NEZAHUALCOYOTL",
    postalCode: "57000",
    suburb: "BENITO JUÁREZ",
    street: "4A. AV.",
    externalNumber: "257",
    coordinates: {
        lat: 19.482992,
        lng: -99.036190
    }
}, {
    name: "CHEDRAUI IZTAPALAPA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: ". 09220",
    suburb: "PROGRESISTA",
    street: "SOTO Y GAMA.",
    externalNumber: "21",
    coordinates: {
        lat: 19.359414,
        lng: -99.063330
    }
}, {
    name: "CHEDRAUI NICOLAS ROMERO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NICOLÁS ROMERO",
    postalCode: "54473",
    suburb: "FRANCISCO SARABIA",
    street: "CARRETERA ATIZAPÁN-NICOLÁS ROMERO",
    externalNumber: "4",
    coordinates: {
        lat: 19.594164,
        lng: -99.279764
    }
}, {
    name: "PLAZA ARAGÓN II",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NEZAHUALCOYOTL",
    postalCode: "55140",
    suburb: "RINCONADA DE ARAGÓN",
    street: "AV. CARLOS HANK GONZÁLEZ",
    externalNumber: "120",
    coordinates: {
        lat: 19.531264,
        lng: -99.026807
    }
}, {
    name: "PLAZA CHALCO 2000",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "CHALCO",
    postalCode: "56600",
    suburb: "EJIDAL CENTRO",
    street: "VICENTE GUERRERO",
    externalNumber: "25",
    coordinates: {
        lat: 19.264639,
        lng: -98.898068
    }
}, {
    name: "PLAZA LAS AMERICAS ECATEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ECATEPEC",
    postalCode: "55075",
    suburb: "CONJUNTO URBANO LAS AMERICAS",
    street: "AV. CENTRAL",
    externalNumber: "S/N LOTE I Y 2",
    coordinates: {
        lat: 19.583619,
        lng: -99.023311
    }
}, {
    name: "PLAZA NEZA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NEZAHUALCOYOTL",
    postalCode: "57809",
    suburb: "REY NEZA",
    street: "CIRCUITO REY NEZA",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.402475,
        lng: -98.987752
    }
}, {
    name: "PLAZA SENDERO VALLE DE CHALCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "VALLE DE CHALCO",
    postalCode: "56615",
    suburb: "MARIA ISABEL",
    street: "AV. INGENIEROS",
    externalNumber: "370",
    coordinates: {
        lat: 19.300350,
        lng: -98.953565
    }
}, {
    name: "PLAZA PUERTA TEXCOCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TEXCOCO",
    postalCode: "58259",
    suburb: "SANTIAGO CUAUTLALPAN",
    street: "CARR. FEDERAL MEXICO-TEXCOCO KM. 30.5",
    externalNumber: "",
    coordinates: {
        lat: 19.427419,
        lng: -98.911888
    }
}, {
    name: "CENTRO DISH COACALCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "COACALCO",
    postalCode: "55720",
    suburb: "PARQUE RESIDENCIAL COACALCO",
    street: "AV. LÓPEZ PORTILLO",
    externalNumber: "220",
    coordinates: {
        lat: 19.626247,
        lng: -99.081585
    }
}, {
    name: "PLAZA SATELITE",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "NAUCALPAN",
    postalCode: "53100",
    suburb: "CD. SATELITE",
    street: "CICUITO COMERCIAL PLAZA SATÉLITE SECTOR E.",
    externalNumber: "2251 LOCAL 192",
    coordinates: {
        lat: 19.510461,
        lng: -99.234220
    }
}, {
    name: "CENTRO DISH EL SALADO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "IZTAPALAPA",
    postalCode: "9170",
    suburb: ".LA COLMENA",
    street: "CAZADA IGNACIO ZARAGOZA",
    externalNumber: "3254 LOCAL D1 Y D2",
    coordinates: {
        lat: 19.367331,
        lng: -99.005429
    }
}, {
    name: "PLAZA PERISUR",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "COYOACAN",
    postalCode: "4500",
    suburb: "AMPLIACION PEDREGAL SAN ANGEL",
    street: "AVENIDA PERIFERICO SUR",
    externalNumber: "4690",
    coordinates: {
        lat: 19.304186,
        lng: -99.190029
    }
}, {
    name: "PLAZA PABELLON POLANCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "MIGUEL HIDALGO",
    postalCode: "11000",
    suburb: "CHAPULTEPEC MORALES",
    street: "AVENIDA EJERCITO NACIONAL",
    externalNumber: "980",
    coordinates: {
        lat: 19.437728,
        lng: -99.207054
    }
}, {
    name: "PLAZA STA FE",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "D.F.",
    city: "CUAJIMALPA",
    postalCode: "5600",
    suburb: "ANTIGUA MINA TOTOLOAPA",
    street: "PROLONGACIÓN VACO DE QUIROGA",
    externalNumber: "3800",
    coordinates: {
        lat: 19.361155,
        lng: -99.273835
    }
}, {
    name: "CENTRO DISH PERICOAPA TOLUCA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TOLUCA - TOLUCA",
    postalCode: "50150",
    suburb: "VÉRTICE",
    street: "PASEO FIDEL VELÁZQUEZ",
    externalNumber: "215",
    coordinates: {
        lat: 19.310620,
        lng: -99.635627
    }
}, {
    name: "REP MEX VALLE DE BRAVO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "VALLE DE BRAVO",
    postalCode: "51200",
    suburb: "SANTA MARIA AHUACATLAN",
    street: "5 DE MAYO",
    externalNumber: "203",
    coordinates: {
        lat: 19.187310,
        lng: -100.127845
    }
}, {
    name: "REP MEX JILOTEPEC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "JILOTEPEC",
    postalCode: "54240",
    suburb: "CENTRO",
    street: "AV. VICENTE GUERRERO PONIENTE",
    externalNumber: "1212",
    coordinates: {
        lat: 19.953294,
        lng: -99.541636
    }
}, {
    name: "REP MEX TEPETLAOXTOC",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TEPETLAOXTOC",
    postalCode: "56070",
    suburb: "TEPETLAOXTOC",
    street: "XOXALTENCO",
    externalNumber: "13",
    coordinates: {
        lat: 19.574063,
        lng: -98.823431
    }
}, {
    name: "REP MEX TEMASCALCINGO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TEMASCALCINGO",
    postalCode: "50400",
    suburb: "CENTRO",
    street: "JOSE VICENTE VILLADA",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.918231,
        lng: -100.004595
    }
}, {
    name: "REP MEX IXTAPAN DE LA SAL",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "IXTAPAN DE LA SAL",
    postalCode: "51900",
    suburb: "CENTRO",
    street: "ALDAMA",
    externalNumber: "2",
    coordinates: {
        lat: 18.846323,
        lng: -99.677786
    }
}, {
    name: "REP MEX OZUMBA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "OZUMBA",
    postalCode: "56800",
    suburb: "CENTRO",
    street: "JOSE ANTONIO ALZATE",
    externalNumber: "83",
    coordinates: {
        lat: 19.035859,
        lng: -98.797026
    }
}, {
    name: "REP MEX JIQUIPILCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "JIQUIPILCO",
    postalCode: "50800",
    suburb: "CENTRO",
    street: "E ZAPATA",
    externalNumber: "113",
    coordinates: {
        lat: 19.556036,
        lng: -99.607811
    }
}, {
    name: "REP MEX TLALMANALCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "TLALMANALCO",
    postalCode: "56700",
    suburb: "CENTRO",
    street: "DR LOPEZ",
    externalNumber: "LT6",
    coordinates: {
        lat: 19.205868,
        lng: -98.801140
    }
}, {
    name: "REP MEX VILLA DE ALLENDE",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "VILLA DE ALLENDE",
    postalCode: "51000",
    suburb: "COL CENTRO",
    street: "ACERCAMIENTO NACIONAL",
    externalNumber: "310",
    coordinates: {
        lat: 19.377504,
        lng: -100.148242
    }
}, {
    name: "REP MEX ATLACOMULCO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ATLACOMULCO",
    postalCode: "50450",
    suburb: "LAGARITA",
    street: "MANUEL DEL MAZO",
    externalNumber: "10",
    coordinates: {
        lat: 19.805448,
        lng: -99.875047
    }
}, {
    name: "REP MEX ACULCO DE ESPINOZA",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "ACULCO DE ESPINOZA",
    postalCode: "50360",
    suburb: "CENTRO",
    street: "MORELOS",
    externalNumber: "23",
    coordinates: {
        lat: 20.099564,
        lng: -99.824821
    }
}, {
    name: "REP MEX APAXCO DE OCAMPO",
    atencion: "LUNES A DOMINGO DE 11:00 AM A 8:00 PM.(0181) 83322190",
    state: "MEXICO",
    city: "APAXCO DE OCAMPO",
    postalCode: "55660",
    suburb: "CENTRO",
    street: "JUAREZ",
    externalNumber: "S/N",
    coordinates: {
        lat: 19.672715,
        lng: -99.179747
    }
}, ];

export default dishonLocations;



// WEBPACK FOOTER //
// ./src/locations/dishonLocations.js